import { render, staticRenderFns } from "./field-file-input.vue?vue&type=template&id=630a8de1&scoped=true&"
import script from "./field-file-input.vue?vue&type=script&lang=js&"
export * from "./field-file-input.vue?vue&type=script&lang=js&"
import style0 from "./field-file-input.vue?vue&type=style&index=0&id=630a8de1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630a8de1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMessages } from 'vuetify/lib/components/VMessages';
installComponents(component, {VExpandTransition,VIcon,VMessages})
